/*
Note:
Komponen ini dipakai di organization-detail (background gelap)
& resource-detail (background terang).
*/

import React from 'react'

const Label = ({children, light}) => {
  return <p className={`text-xs ${light? 'text-white' : 'text-gray-999'} opacity-50`}>{children}</p>
}

const Value = ({children, light}) => {
  return <p className={`text-sm leading-tight ${light ? 'text-white' : 'text-gray-444'}`}>{children}</p>
}

const Meta = ({label, value, className, light}) => {
  return (
    <div className={`font-medium ${className}`}>
      <Label light={light}>{label}</Label>
      <Value light={light}>{value ? value : ''}</Value>
    </div>
  )
}

export { Meta }
